/* DUO cart value lines (snippets/duo-cart-value.liquid): the free delivery
   meter, the pack line and "On this order you save".
   They are rendered by Liquid inside the cart drawer, so Horizon's own
   re-render after every cart change keeps them current. This covers the one
   gap: the drawer opening on a cart that changed somewhere else (another tab,
   or an add that did not re-render the drawer). It compares the cart with the
   drawer's signature (items:total) and re-renders the drawer if they differ. */
import { sectionRenderer } from '@theme/section-renderer';

const drawer = document.getElementById('cart-drawer');

if (drawer && !drawer.dataset.duoCv) {
  drawer.dataset.duoCv = '1';
  drawer.addEventListener('theme-drawer:open', async () => {
    const inner = drawer.querySelector('[data-duo-cart-sig]');
    if (!inner) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      if (inner.dataset.duoCartSig === cart.item_count + ':' + cart.total_price) return;
      await sectionRenderer.renderSection('cart-drawer-section', {
        cache: false,
        mode: 'hydration',
        // empty to full adds the summary markup, which carries its own stylesheet
        injectStylesheet: inner.classList.contains('cart-drawer--empty'),
      });
    } catch (e) {
      /* keep what the page rendered */
    }
  });
}

/* v3 (Oct 28, spec #cart): "One for them" (snippets/duo-cart-value.liquid part 'them'). One tap adds
   that Little, just the drink, and the cart is redrawn in place from the same answer, the way
   assets/duo.js redraws it after a quantity change ('shopify:cart:lines-update'); a full reload only
   if that is not possible. One handler on the page, so a redrawn cart needs nothing re-bound. */
if (!window.__duoThem) {
  window.__duoThem = true;
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-duo-them-add]');
    if (!b || b.disabled) return;
    b.disabled = true;
    b.classList.add('is-busy');
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((c) => {
      const id = c.dataset.sectionId;
      if (id && !ids.includes(id)) ids.push(id);
    });
    const body = { updates: { [b.dataset.duoThemAdd]: 1 } };
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = location.pathname;
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('add'))))
      .then((j) => {
        if (j.sections && ids.length && ids.every((id) => j.sections[id])) {
          const ev = new Event('shopify:cart:lines-update', { bubbles: true });
          ev.duoTidy = true; // a Little only: nothing for assets/duo.js tidyCart to sweep
          ev.promise = Promise.resolve({ cart: { totalQuantity: j.item_count }, detail: { sections: j.sections, itemCount: j.item_count } });
          document.dispatchEvent(ev);
        } else location.reload();
      })
      .catch(() => {
        b.disabled = false;
        b.classList.remove('is-busy');
      });
  });
}
